import { render, staticRenderFns } from "./MessageCreationInfoBtn.vue?vue&type=template&id=c560f684&scoped=true&"
import script from "./MessageCreationInfoBtn.vue?vue&type=script&lang=ts&"
export * from "./MessageCreationInfoBtn.vue?vue&type=script&lang=ts&"
import style0 from "./MessageCreationInfoBtn.vue?vue&type=style&index=0&id=c560f684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c560f684",
  null
  
)

export default component.exports